/**
 * Los mensajes del protocolo van a la consola del navegador, aparte de la salida
 * del sketch del usuario que se ve en el monitor serie.
 *
 * Van con prefijo y color propios para que se distingan de un vistazo entre todo
 * lo demás que loguea la app, y con el nombre del puerto adelante porque puede
 * haber más de una placa enchufada.
 */

const STYLE = {
  tag: 'background:#00a99d;color:#fff;padding:1px 5px;border-radius:3px;font-weight:bold',
  event: 'background:#f5a623;color:#fff;padding:1px 5px;border-radius:3px;font-weight:bold',
  reset: '',
};

const write = (level, style, label, port, ...args) => {
  /* eslint-disable no-console */
  const log = console[level] || console.log;
  log(`%c${label}%c ${port || ''}`, style, STYLE.reset, ...args);
  /* eslint-enable no-console */
};

export const logProtocol = (port, ...args) => write('log', STYLE.tag, 'EDU', port, ...args);

// Los eventos que manda la placa sola se marcan distinto de lo que contesta a un
// pedido nuestro: no vienen de un ping, vienen de algo que pasó en la placa.
export const logEvent = (port, ...args) => write('log', STYLE.event, 'EDU evento', port, ...args);

export const logProtocolError = (port, ...args) => write('warn', STYLE.tag, 'EDU', port, ...args);

export default logProtocol;
